/* eslint-disable import/no-anonymous-default-export */
import config from '../shared/config';

export default (url) => {
  if (!url) {
    return;
  }
  let fileUrl = url;
  if (!/^https?:\/\//.test(url)) {
    fileUrl = `${config.apiUrl}${url}`;
  }

  return fileUrl;
};
